/**
 * Copyright (c) samjay.dev.
 *
 * Notes:
 * This source code is the private property of samjay.dev.
 * You cannot modify, share or copy these source codes without any formal authorization,
 * otherwise samjay.dev reserves the right to pursue any legal action.
 *
 * Developer: Sam Tsang (info@samjay.dev)
 */

import React, { useState } from 'react';
import { InView } from 'react-intersection-observer';
import { useNavigate } from 'react-router-dom';
import { getSvgIcon } from 'resources';
import AppStyle from 'scss/main/App.module.scss';
import { useGetListQuery } from 'services/blog.sevices';

const Blog: React.FC<{}> = ({
  
}) => {

  const navigate = useNavigate();
  const { data } = useGetListQuery({items: 100});

  const [index, setIndex] = useState(0);

  return (
    <div className={AppStyle['blog']}>
      <div>
        <InView triggerOnce>
          {({ inView, ref }) => (
            <div className={`${inView && AppStyle['descAnimI']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
              <div>Sam's Blog</div>
              <div dangerouslySetInnerHTML={{__html: `${getSvgIcon({name: 'blog-text'})}`}} />
            </div>
          )}
        </InView>
      </div>
      <div>
        <InView triggerOnce>
          {({ inView, ref }) => (
            <div className={`${inView && AppStyle['descAnimA']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
              <div onClick={() => setIndex(0)} className={index === 0 ? AppStyle['active'] : ''}>All</div>
              <div onClick={() => setIndex(1)} className={index === 1 ? AppStyle['active'] : ''}>Programming</div>
              {/* <div onClick={() => setIndex(2)} className={index === 2 ? AppStyle['active'] : ''}>Happiness</div> */}
            </div>
          )}
        </InView>
        <div>
          {
            data?.success && data?.results.length > 0 ?
                data?.results.map((d, i) => <InView triggerOnce>
                {({ inView, ref }) => (
                  <div onClick={() => navigate(`${d.aid}`) } key={`blog-list-${i}`} className={`${inView && AppStyle['descAnimI']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
                    <div>
                      <div style={{backgroundImage: `url('${d.cover}')`}} />
                      <div style={{backgroundImage: `url('${process.env.REACT_APP_CDN_PATH}7cadf466539111ee8c990242ac120002.webp')`}} />
                    </div>
                    <div>{d.title}</div>
                    <div>
                      {<div>{d.tags.split(',').join(' · ')}</div>}
                    </div>
                  </div>
                )}
              </InView>)
            : <noindex><InView triggerOnce>
            {({ inView, ref }) => (
              <div className={`${inView && AppStyle['descAnimA']}`} style={{ opacity: !inView ? '0.0' : '1.0' }} ref={ref}>
                <div>I haven’t prepared any content yet!</div>
              </div>
            )}
          </InView></noindex>
          }
        </div>
      </div>
    </div>
  );
}

export default Blog;